"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var router_1 = require("@angular/router");
var services_1 = require("../../services");
var constants_1 = require("../../utilities/constants");
var VCConfigurationComponent = /** @class */ (function () {
    function VCConfigurationComponent(router, webRTC, mediaDevicesService, networkService, vcCmsService) {
        this.router = router;
        this.webRTC = webRTC;
        this.mediaDevicesService = mediaDevicesService;
        this.networkService = networkService;
        this.vcCmsService = vcCmsService;
        this.isVoiceOn = false;
        this.isCameraOn = true;
        this.cameras = [];
        this.microphones = [];
        this.speakers = [];
        this.isMediaPermissionDenied = false;
        this.hasProblemWithDevices = false;
        this.onCancel = new core_1.EventEmitter();
        this.onJoin = new core_1.EventEmitter();
    }
    VCConfigurationComponent.prototype.ngOnInit = function () {
        this.loadSittingData();
    };
    VCConfigurationComponent.prototype.loadSittingData = function () {
        var _this = this;
        Promise.all([this.vcCmsService.getSessionUserInfo(this.sessionId),
            this.networkService.getSessionStatus(this.sessionId)])
            .then(function (_a) {
            var _b = _a[0], currentUser = _b.currentUser, roles = _b.roles, createdAt = _a[1].createdAt;
            _this.isDataLoaded = true;
            currentUser.userRole = roles[currentUser['userRoleId']];
            _this.participantInfo = currentUser;
            if (createdAt) {
                _this.isSessionStarted = true;
                _this.init();
            }
            else if (!currentUser['hasAccessToParticipate']) {
                return Promise.reject({ status: 403 });
            }
            else {
                _this.isModerator = constants_1.AppConstants.isModerator(_this.participantInfo.connectionRole);
                if (!_this.isModerator) {
                    setTimeout(function () {
                        _this.loadSittingData();
                    }, 10000);
                }
                else {
                    _this.init();
                }
            }
        })
            .catch(function (error) {
            console.warn(error);
            _this.isDataLoaded = false;
            _this.forbidden = true;
        });
    };
    VCConfigurationComponent.prototype.ngOnDestroy = function () {
        this.clearMediaStream();
    };
    VCConfigurationComponent.prototype.clearMediaStream = function () {
        this.mediaStream && this.mediaStream.getTracks().forEach(function (track) {
            track.stop();
        });
    };
    VCConfigurationComponent.prototype.init = function () {
        var _this = this;
        this.webRTC.initialize(this.sessionId);
        this.account = this.webRTC.getAccount();
        // for requesting permission to use camera and microphone
        var constraints = {
            audio: true,
            video: true
        };
        this.requestMediaStream(constraints)
            .then(function () {
            if (!_this.isMediaPermissionDenied) {
                _this.setupDevices();
            }
        });
        this.registerDeviceChangeHandler();
    };
    VCConfigurationComponent.prototype.join = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.sessionId) {
                    this.account.activeAudio = this.isVoiceOn;
                    this.account.activeVideo = this.isCameraOn;
                    this.mediaDevicesService.selectedCamera = this.selectedCamera;
                    this.mediaDevicesService.selectedMicrophone = this.selectedMicrophone;
                    this.mediaDevicesService.selectedSpeaker = this.selectedSpeaker;
                    this.onJoin.emit(true);
                }
                return [2 /*return*/];
            });
        });
    };
    VCConfigurationComponent.prototype.toggleVoice = function () {
        this.isVoiceOn = !this.isVoiceOn;
        this.requestMediaStream();
    };
    VCConfigurationComponent.prototype.toggleCamera = function () {
        this.isCameraOn = !this.isCameraOn;
        this.requestMediaStream();
    };
    VCConfigurationComponent.prototype.onAudioDeviceChange = function (deviceId) {
        this.selectedMicrophone = deviceId || this.microphones[0].deviceId;
        this.requestMediaStream();
    };
    VCConfigurationComponent.prototype.onCameraDeviceChange = function (deviceId) {
        this.selectedCamera = deviceId || this.cameras[0].deviceId;
        this.requestMediaStream();
    };
    VCConfigurationComponent.prototype.onSpeakerDeviceChange = function (deviceId) {
        this.selectedSpeaker = deviceId || this.speakers[0].deviceId;
    };
    VCConfigurationComponent.prototype.cancel = function () {
        this.onCancel.emit();
    };
    VCConfigurationComponent.prototype.requestMediaStream = function (inputConstraints) {
        var _this = this;
        this.clearMediaStream();
        if (this.isCameraOn || this.isVoiceOn) {
            var constraints = {
                video: this.isCameraOn && {
                    deviceId: this.selectedCamera
                },
                audio: this.isVoiceOn && {
                    deviceId: this.selectedMicrophone
                }
            };
            return navigator.mediaDevices.getUserMedia(inputConstraints || constraints)
                .then(function (stream) {
                _this.mediaStream = stream;
                _this.mediaStream.getAudioTracks().length && (_this.mediaStream.getAudioTracks()[0].enabled = _this.isVoiceOn);
            })
                .catch(function (error) {
                _this.isMediaPermissionDenied = true;
                console.error(error);
            });
        }
        return Promise.resolve();
    };
    VCConfigurationComponent.prototype.registerDeviceChangeHandler = function () {
        var _this = this;
        navigator.mediaDevices.ondevicechange = function (event) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.setupDevices()];
                    case 1:
                        _a.sent();
                        this.requestMediaStream();
                        return [2 /*return*/];
                }
            });
        }); };
    };
    VCConfigurationComponent.prototype.setupDevices = function () {
        return __awaiter(this, void 0, void 0, function () {
            var devices, audioDevice, videoDevice, audioOutputDevice;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.mediaDevicesService.getDevices()];
                    case 1:
                        devices = _a.sent();
                        this.hasProblemWithDevices = false;
                        if (devices.cameras.length !== this.cameras.length || this.microphones.length !== devices.microphones.length) {
                            this.cameras = devices.cameras.filter(function (device) { return device.label; });
                            this.microphones = devices.microphones.filter(function (device) { return device.label; });
                            this.speakers = devices.speakers.filter(function (device) { return device.label; });
                            audioDevice = this.microphones.find(function (microphone) { return microphone.deviceId === _this.selectedMicrophone; });
                            this.selectedMicrophone = null;
                            this.selectedMicrophone = audioDevice ? audioDevice.deviceId : this.microphones && this.microphones[0].deviceId;
                            videoDevice = this.cameras.find(function (camera) { return camera.deviceId === _this.selectedCamera; });
                            this.selectedCamera = null;
                            this.selectedCamera = videoDevice ? videoDevice.deviceId : this.cameras[0] && this.cameras[0].deviceId;
                            audioOutputDevice = this.cameras.find(function (speaker) { return speaker.deviceId === _this.selectedSpeaker; });
                            this.selectedSpeaker = null;
                            this.selectedSpeaker = audioOutputDevice ? audioOutputDevice.deviceId : this.speakers[0] && this.speakers[0].deviceId;
                        }
                        // browsers doesn't support speaker change and always use default speaker, so now just not checking this.speakers.length
                        if (!this.cameras.length || !this.microphones.length) {
                            this.hasProblemWithDevices = true;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], VCConfigurationComponent.prototype, "sessionId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], VCConfigurationComponent.prototype, "token", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], VCConfigurationComponent.prototype, "onCancel", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], VCConfigurationComponent.prototype, "onJoin", void 0);
    VCConfigurationComponent = __decorate([
        core_1.Component({
            selector: 'sis-vc-configuration',
            template: require('./vc-configuration.component.html'),
            styles: [require('./vc-configuration.component.css')]
        }),
        __metadata("design:paramtypes", [router_1.Router,
            services_1.WebRTCService,
            services_1.MediaDevicesService,
            services_1.NetworkService,
            services_1.IVCCmsService])
    ], VCConfigurationComponent);
    return VCConfigurationComponent;
}());
exports.VCConfigurationComponent = VCConfigurationComponent;
//# sourceMappingURL=vc-configuration.component.js.map